import actionTypes from '../../actions/actionTypes'
import requestStatus from '../../constants/requestStatus'
import { Map, fromJS, List } from 'immutable';
import { returnStateIfNoAction } from '../helpers';
import { onGet, onError } from '../helpers-request';

const INIT_STATE = Map({
    status: requestStatus.INITIALIZED,
    error: null,
    items: Map(), // <id, page>
    order: List() // <id>
})

const onSuccess = (state, action)     => state.set('status', requestStatus.REQUEST_SUCCESS)
                                                .set('items', fromJS(action.payload.items))
                                                .set('order', fromJS(action.payload.order))


const wpReducerFactory = (requestAction, successAction, errorAction) => (state = INIT_STATE, action) => {
    returnStateIfNoAction(action, state)

    switch(action.type) {
        case actionTypes[requestAction]:
            return onGet(state);
        case actionTypes[successAction]:
            return onSuccess(state, action);
        case actionTypes[errorAction]:
            return onError(state, action);
        default:
            return state;
    }
}

export default wpReducerFactory